import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiService } from '@shared/services/api.service';
import { Widget } from '@shared/models/widget.model';
import { DataResponse, ListResponse, SuccessResponse } from '@shared/models/response.model';
import { Cacheable, CacheBuster } from 'ts-cacheable';

const cacheNotifier: Subject<void> = new Subject();
@Injectable({
  providedIn: 'root'
})
export class WidgetService {

  constructor(private api: ApiService) {}

  @CacheBuster({
      cacheBusterNotifier: cacheNotifier
  })
  getList(params?: object): Observable<ListResponse<Widget>> {
    return this.api.get(`/widgets`, params);
  }

  getById(id): Observable<Widget> {
    return this.api.get(`/widget/${id}`);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  create(data: object): Observable<DataResponse<Widget>> {
    return this.api.post(`/widget`, data);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  update(id: number, data: object): Observable<DataResponse<Widget>> {
    return this.api.put(`/widget/${id}`, data);
  }

  @CacheBuster({
    cacheBusterNotifier: cacheNotifier
  })
  delete(id: number): Observable<SuccessResponse> {
    return this.api.delete(`/widget/${id}`);
  }

  static clearCache() {
    cacheNotifier.next();
  }
}
